/**
 * sessions.js
 *
 * Defines constants for different session types used in the application.
 * Used for filtering or labeling session-related data.
 */

export const AM_SESSION = 'AM Session'; // Morning session
export const PM_SESSION = 'PM Session'; // Afternoon session
export const PLENARY = 'Plenary'; // Plenary session
